"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = void 0;

var _preact = require("preact");

var Section = function Section(_ref) {
  var title = _ref.title,
      customClass = _ref.customClass,
      children = _ref.children;
  return (0, _preact.h)("div", {
    className: "section-wrapper ".concat(customClass)
  }, (0, _preact.h)("div", {
    className: "section-header"
  }, (0, _preact.h)("div", {
    className: "section-header-title"
  }, title)), (0, _preact.h)("div", {
    className: "section-body"
  }, children));
};

exports.Section = Section;